import { QueryV2Params, useSubscriberV2 } from 'services/api/hooks';
import React from 'react';
import { LiveStatusIndicator } from 'common/ui';

export const SubscriberIndicator = ({
  subscriberQueries
}: {
  subscriberQueries: QueryV2Params[];
}) => {
  const { error } = useSubscriberV2({
    queries: subscriberQueries,
    disableOnEvents: true
  });

  return <LiveStatusIndicator isLive={!error} />;
};
